// Cross-arm checks for page 4 (The treatments), shared by the page (inline messages) and the
// wizard (blocking "Next").

const normalizeLabel = (label) => (label || '').trim().toLowerCase();

/** Ids of treatment arms whose label matches another arm's (ignoring case and spacing). */
export const duplicateLabelIds = (treatments) => {
  const arms = treatments.filter((t) => !t.is_control && normalizeLabel(t.treatment_label));
  const counts = arms.reduce((acc, t) => {
    const key = normalizeLabel(t.treatment_label);
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});
  return new Set(arms.filter((t) => counts[normalizeLabel(t.treatment_label)] > 1).map((t) => t.id));
};

/**
 * The arms' N (treatments + control) against the total N from page 3, or null when there's
 * nothing to compare yet: no total entered, or an arm still missing its N.
 */
export const armSizeMismatch = (treatments, totalN) => {
  const total = totalN === '' || totalN === null || totalN === undefined ? null : Number(totalN);
  if (total === null || Number.isNaN(total) || treatments.length === 0) return null;
  if (treatments.some((t) => t.initial_n === null || t.initial_n === undefined || t.initial_n === '')) {
    return null;
  }
  const sum = treatments.reduce((acc, t) => acc + Number(t.initial_n), 0);
  return sum === total ? null : { sum, total };
};
